/* istanbul ignore file */

export const CONTACT_CONSTANTS = {
    ENTERPRISE_LICENSE_EMAIL: 'SMARTS@kimley-horn.com',
};
